import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { InsuranceControlModule } from '@app/my-zone/shared/insurance-control/insurance-control.module';
import { InsuranceListModule } from '@app/my-zone/shared/insurance-list/insurance-list.module';
import { NewHomeFeedbackModule } from '@app/my-zone/shared/new-home-feedback/new-home-feedback.module';
import { WucPriceModule, WucRackModule } from '@inshared/website-ui-components';
import { OutInsurancePolicyModule } from 'outshared-lib';
import { PassportModule } from '../../shared/passport/passport.module';
import { InsurancesRoutingModule } from './insurances-routing.module';
import { InsurancesComponent } from './insurances.component';
import { InsurancesContainer } from './insurances.container';

/** @deprecated - insurances functionality is moved to libs/my-zone/insurances */
@NgModule({
    imports: [
        CommonModule,
        InsurancesRoutingModule,
        PassportModule,
        InsuranceListModule,
        NewHomeFeedbackModule,
        InsuranceControlModule,
        OutInsurancePolicyModule,
        WucPriceModule,
        WucRackModule,
    ],
    declarations: [InsurancesContainer, InsurancesComponent],
})
export class InsurancesModule {}
